(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !window.DesignMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-old"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(e) {
      if (e.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(e) {
      e.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = e.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(e) {
      const shouldClose = e.relatedTarget && e.relatedTarget.nodeName === 'BUTTON';
      if (e.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(e) {
      if (e.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(e) {
      e.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = e.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(e) {
      const shouldClose = e.relatedTarget && e.relatedTarget.nodeName === 'BUTTON';
      if (e.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.header = document.getElementById('shopify-section-header');
        this.headerBounds = {};
        this.currentScrollTop = 0;
        this.preventReveal = false;

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });

        observer.observe(this.header);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          console.log('hey scrollTop is greater than currentScrollTop and less than headerBounds.bottom');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }

        console.log('st:', scrollTop, 'this.st', this.currentScrollTop, "this.headerBounds:", this.headerBounds, 'this.headerBounds.top:', this.headerBounds.top);
        this.currentScrollTop = scrollTop;
      }

      hide() {
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        console.log('RESET CALLED');
      }

      closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
        this.disclosures.forEach(disclosure => disclosure.close());
      }

      closeSearchModal() {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        this.searchModal.close(false);
      }
    }

    customElements.define('sticky-header', StickyHeader);

    class OmniHeader extends StickyHeader {
      constructor() {
        super();
      }

      connectedCallback() {
        this.isOverlay = false;
        let headerHeight = document.body.querySelector('omni-header .header').offsetHeight;
        console.log('headerHeight:', headerHeight);
        document.body.style.setProperty('--omni-header-height', `${headerHeight}px`)
        // Check for masthead
        if (document.querySelector('.js-masthead')) {
          // add overlay class if masthead present
          this.isOverlay = true;
          this.classList.add('is-overlay');
        }
        // Check for WW SVG
        this.logo = document.getElementById('wwLogo');
        this.header = document.getElementById('shopify-section-header');
        this.headerBounds = {};
        this.currentScrollTop = 0;

        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);


      if (!window.pageYOffset) {
          this.header.classList.add('at-top');
        }
        this.createObserver();
      }

      disconnectedCallback() {
        super.disconnectedCallback();
      }

      createObserver() {
        super.createObserver();
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop <= 30) {
          this.header.classList.add('at-top');
          this.logo.setAttribute('viewBox', '0 0 160 60');
          this.logo.getElementById('wwLogotype')?.classList.remove('is-hidden');
          let headerHeight = document.body.querySelector('omni-header .header').offsetHeight;
          document.body.style.setProperty('--omni-header-height', `${headerHeight}px`)
        } else {
          this.header.classList.remove('at-top');
          this.logo.setAttribute('viewBox', '0 0 160 43');
          this.logo.setAttribute('height', '40px');
          this.logo.getElementById('wwLogotype')?.classList.add('is-hidden');
          let headerHeight = document.body.querySelector('omni-header .header').offsetHeight;
          document.body.style.setProperty('--omni-header-height', `${headerHeight}px`)
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        this.header.classList.add('shopify-section-header-hidden');
        this.header.classList.remove('will-hide');
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        this.header.classList.add('animate');
        this.header.classList.remove('shopify-section-header-hidden', 'will-hide');
      }

      reset() {
        this.header.classList.remove('shopify-section-omni-header-hidden', 'shopify-section-header-fixed', 'animate');
        console.log('Fixed Header Reset');
      }

      closeMenuDisclosure() {
        super.closeMenuDisclosure();
      }

      closeSearchModal() {
        super.closeSearchModal();
      }

    }

    customElements.define('omni-header', OmniHeader);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((e) => {
        const body = JSON.stringify({ note: e.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-masthead"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  // ProductMain maps roughly to product.js in slater, meant to fire Klaviyo and FB Tracking if needed
  // In slater, also handles add to cart, but that's handled by product-form.js here.
  class ProductMain extends HTMLElement {
    constructor() {
      super();
      this.opts = productSelection(this);

      // builds cache
      getProductJson();

      this.opts.onUpdate((state) => {
        getProductJson().then((json) => {
          this.variant = json.variants.filter(v => v.id == state.id)[0];
        })
      })

      this.json = JSON.parse(document.querySelector('.js-product-json').innerHTML);
      this.form = this.querySelector("[data-type='add-to-cart-form']");
    }

    connectedCallback() {
      const { selectedOrFirstAvailableVariant, product } = this.json;
      let currentVariant = product.variants.filter(v => v.id === selectedOrFirstAvailableVariant)[0];

      this.form.addEventListener('submit', (e) => {
        e.preventDefault();

        console.log('hi from product-main', e);
        console.log('currentVariant is -', currentVariant);
      });
    }
  }

  customElements.define('product-main', ProductMain)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-prelaunch"]) return;
  try {
    
  // ProductMain maps roughly to product.js in slater, meant to fire Klaviyo and FB Tracking if needed
  // In slater, also handles add to cart, but that's handled by product-form.js here.
  class ProductMain extends HTMLElement {
    constructor() {
      super();
      this.opts = productSelection(this);

      // builds cache
      getProductJson();

      this.opts.onUpdate((state) => {
        getProductJson().then((json) => {
          this.variant = json.variants.filter(v => v.id == state.id)[0];
          console.log('new variant is', this.variant);
        })
      })

      this.json = JSON.parse(document.querySelector('.js-product-json').innerHTML);
      this.form = this.querySelector("[data-type='add-to-cart-form']");
    }

    connectedCallback() {
      const { selectedOrFirstAvailableVariant, product } = this.json;
      let currentVariant = product.variants.filter(v => v.id === selectedOrFirstAvailableVariant)[0];

      // Klaviyo BIS Logic
      const loadScriptAsync = function loadAndBuildScript(uri, id, scriptName = 'Klaviyo Onsite') {
        return new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = uri;
          script.async = true;
          script.id = id;
          script.onload = () => {
            resolve(`${scriptName} Successfully Loaded`);
          };
          const body = document.body;
          body.append(script);
        });
      };
      const rnd = Math.floor(Math.random() * 80000);
      const klaviyoScriptLoaded = loadScriptAsync(`https://a.klaviyo.com/media/js/onsite/onsite.js?r=${rnd}`, 'js-klaviyo-async');

      // Once we've got Klaviyo, do something.
      klaviyoScriptLoaded.then(() => {
        console.log(`[Klaviyo / Onsite] Loaded.`);
        if (window._klOnsite) {
          const klaviyoOnsite = window._klOnsite || [];
          const prelaunchBtn = document.querySelector('.klaviyo-prelaunch-trigger');
          const prelaunchData = document.querySelector('[data-prelaunch]');
          const prelaunchListID = prelaunchData.getAttribute('data-list-id');
          prelaunchBtn.classList.add('is-visible');

          prelaunchBtn.addEventListener('click', (e) => {
            e.preventDefault();

            console.log('Prelaunch Button Clicked')
            window._klOnsite.openForm([prelaunchListID]);
          })
        }
      }).catch((reason) => {
        console.log(`Script load failure - ${reason}`);
      });
    }
  }
  customElements.define('product-main', ProductMain)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-secondary"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  // ProductMain maps roughly to product.js in slater, meant to fire Klaviyo and FB Tracking if needed
  // In slater, also handles add to cart, but that's handled by product-form.js here.
  class ProductMain extends HTMLElement {
    constructor() {
      super();
      this.opts = productSelection(this);

      // builds cache
      getProductJson();

      this.opts.onUpdate((state) => {
        getProductJson().then((json) => {
          this.variant = json.variants.filter(v => v.id == state.id)[0];
          console.log('new variant is', this.variant);
        })
      })

      this.json = JSON.parse(document.querySelector('.js-product-json').innerHTML);
      this.form = this.querySelector("[data-type='add-to-cart-form']");
    }

    connectedCallback() {
      const { selectedOrFirstAvailableVariant, product } = this.json;
      let currentVariant = product.variants.filter(v => v.id === selectedOrFirstAvailableVariant)[0];

      // Klaviyo BIS Logic
      const loadScriptAsync = function loadAndBuildScript(uri, id, scriptName = 'Klaviyo Onsite') {
        return new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = uri;
          script.async = true;
          script.id = id;
          script.onload = () => {
            resolve(`${scriptName} Successfully Loaded`);
          };
          const body = document.body;
          body.append(script);
        });
      };
      const rnd = Math.floor(Math.random() * 80000);
      const klaviyoScriptLoaded = loadScriptAsync(`https://a.klaviyo.com/media/js/onsite/onsite.js?r=${rnd}`, 'js-klaviyo-async');

      // Once we've got Klaviyo, do something.
      klaviyoScriptLoaded.then(() => {
        console.log(`[Klaviyo / Onsite] Loaded.`);
        if (window.klaviyo) {
          const klaviyo = window.klaviyo;
          klaviyo.init({
            account: 'RNmLrw',
            platform: 'shopify',
            exclude_on_tags: 'limited-edition, discontinued',
          });
          klaviyo.enable('backinstock', {
            modal: {
              headline: '{product_name}',
              body_content: 'Register to receive a notification when this item comes back in stock.',
              email_field_label: 'Email',

              button_label: 'Notify me',
              subscription_success_label: 'We\'ll be in touch as soon as {product_name} becomes available.',

              footer_content: '',
              close_label: 'Close',

              additional_styles: "@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;600');body.klaviyo-bis-close{ display: flex; align-items: center; justify-content: center;}#klaviyo-bis-modal{ display: flex; }@media only screen and (max-width:991.92px) { #klaviyo-bis-modal { max-width: calc(100% - 4rem); } }#container { margin-top: 0 !important; }.close{ right: 12px; }.modal-title { font-family: 'Space Grotesk'; font-weight: 400;}.btn { font-size: 1.25em; font-family: 'Space Grotesk';}",
              font_family: '"Space Grotesk", sans-serif;',

              drop_background_color: '#191919',
              background_color: '#f0f0f0',
              text_color: '#191919',
              button_text_color: '#f0f0f0',
              button_background_color: '#191919',
              close_button_color: '#ccc',
              error_background_color: '#fcd6d7',
              error_text_color: '#C72E2F',
              success_background_color: '#d3efcd',
              success_text_color: '#1B9500',
            },
          });
          const bisBtn = document.querySelector('.klaviyo-bis-trigger');
          bisBtn.classList.add('is-visible');
          console.log('Back In Stock Fired');
        }
      }).catch((reason) => {
        console.log(`Script load failure - ${reason}`);
      });
    }
  }

  customElements.define('product-main', ProductMain)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  // ProductMain maps roughly to product.js in slater, meant to fire Klaviyo and FB Tracking if needed
  // In slater, also handles add to cart, but that's handled by product-form.js here.
  class ProductMain extends HTMLElement {
    constructor() {
      super();
      this.opts = productSelection(this);

      // builds cache
      getProductJson();

      this.opts.onUpdate((state) => {
        getProductJson().then((json) => {
          this.variant = json.variants.filter(v => v.id == state.id)[0];
          console.log('new variant is', this.variant);
        })
      })

      this.json = JSON.parse(document.querySelector('.js-product-json').innerHTML);
      this.form = this.querySelector("[data-type='add-to-cart-form']");
    }

    connectedCallback() {
      const { selectedOrFirstAvailableVariant, product } = this.json;
      let currentVariant = product.variants.filter(v => v.id === selectedOrFirstAvailableVariant)[0];

      // Klaviyo BIS Logic
      const loadScriptAsync = function loadAndBuildScript(uri, id, scriptName = 'Klaviyo Onsite') {
        return new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = uri;
          script.async = true;
          script.id = id;
          script.onload = () => {
            resolve(`${scriptName} Successfully Loaded`);
          };
          const body = document.body;
          body.append(script);
        });
      };
      const rnd = Math.floor(Math.random() * 80000);
      const klaviyoScriptLoaded = loadScriptAsync(`https://a.klaviyo.com/media/js/onsite/onsite.js?r=${rnd}`, 'js-klaviyo-async');

      // Once we've got Klaviyo, do something.
      klaviyoScriptLoaded.then(() => {
        console.log(`[Klaviyo / Onsite] Loaded.`);
        if (window.klaviyo) {
          const klaviyo = window.klaviyo;
          klaviyo.init({
            account: 'RNmLrw',
            platform: 'shopify',
            exclude_on_tags: 'limited-edition, discontinued',
          });
          klaviyo.enable('backinstock', {
            modal: {
              headline: '{product_name}',
              body_content: 'Register to receive a notification when this item comes back in stock.',
              email_field_label: 'Email',

              button_label: 'Notify me',
              subscription_success_label: 'We\'ll be in touch as soon as {product_name} becomes available.',

              footer_content: '',
              close_label: 'Close',

              additional_styles: "@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;600');body.klaviyo-bis-close{ display: flex; align-items: center; justify-content: center;}#klaviyo-bis-modal{ display: flex; }@media only screen and (max-width:991.92px) { #klaviyo-bis-modal { max-width: calc(100% - 4rem); } }#container { margin-top: 0 !important; }.close{ right: 12px; }.modal-title { font-family: 'Space Grotesk'; font-weight: 400;}.btn { font-size: 1.25em; font-family: 'Space Grotesk';}",
              font_family: '"Space Grotesk", sans-serif;',

              drop_background_color: '#191919',
              background_color: '#f0f0f0',
              text_color: '#191919',
              button_text_color: '#f0f0f0',
              button_background_color: '#191919',
              close_button_color: '#ccc',
              error_background_color: '#fcd6d7',
              error_text_color: '#C72E2F',
              success_background_color: '#d3efcd',
              success_text_color: '#1B9500',
            },
          });
          const bisBtn = document.querySelector('.klaviyo-bis-trigger');
          bisBtn.classList.add('is-visible');
          console.log('Back In Stock Fired');
        }
      }).catch((reason) => {
        console.log(`Script load failure - ${reason}`);
      });
    }
  }

  customElements.define('product-main', ProductMain)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team-members"] && !window.DesignMode) return;
  try {
    
if (!customElements.get('team-members')) {
  customElements.define('team-members', class TeamMembers extends HTMLElement {
    constructor() {
      self = super();
      this._internals = this.attachInternals();
      console.log('Team Members initialized');
    }

    connectedCallback() {
      const grid = self.querySelector('.team-members__grid');
      const popup_enabled = grid.dataset.enablePopup == "true" ? true : false;
      const gridChildren = Array.from(grid.children);
      const active = grid.querySelector(`.is-active`)
      

      this.currentActive = null;

      const modal = document.getElementById('team-member-modal');
      const modalContent = document.getElementById('team-modal-content');
      const modalClose = modal.querySelector('.team-modal__close');
      const modalOverlay = modal.querySelector('.team-modal__overlay');
      
      const openModal = (templateId) => {
      const template = document.getElementById(templateId);

        if (template && modalContent) {
        modalContent.innerHTML = ''; // Clear previous content
        modalContent.appendChild(template.content.cloneNode(true));
        const media = modal.getElementsByClassName('team-memeber__media')[0];
        if(window.screen.width < 750){
          media?.addEventListener('click', () => {
            media.classList.toggle('active');
          });
        }
        modal.showModal()
        }
      };

      const closeModal = () => {
        modal.close()
        modalContent.innerHTML = '';
      };

      modalClose?.addEventListener('click', closeModal);
      modalOverlay?.addEventListener('click', closeModal);

      gridChildren.forEach((child, index) => {
        if(popup_enabled) {
          child.addEventListener('click', (event) => {
          const modalData = event.currentTarget.querySelector('.team-member__long-content');
          openModal(modalData.id); 
          // if (child !== this.currentActive) {
          //   if (this.currentActive) {
          //    this.currentActive
          //      .classList.remove('is-active');
          //  }
            // Set active item
          //  child.classList.add('is-active' );
          //  this.currentActive = child;
          // }
          // child.classList.add('is-active');
          // console.log('honk honk', child);

          // navigateItems(grid, this);
          })
        }
      });

      const navigateItems = (gridSelector, caller) => {
        const grid = gridSelector;
        const active = grid.querySelector(`.is-active`);
        const activeIndex = Array.from(grid.children).indexOf(active);

        const gridChildren = Array.from(grid.children);
        const gridNum = gridChildren.length;
        const baseOffset = gridChildren[0].offsetTop;
        const breakIndex = gridChildren.findIndex(item => item.offsetTop > baseOffset);
        const numPerRow = (breakIndex === -1 ? gridNum : breakIndex);

        if (caller !== this.currentActive) {
          console.log('OH NO');
          if (this.currentActive) {
            this.currentActive
              .classList.remove('is-active');
          }
          // Set active item
          caller.classList.add('is-active');
          this.currentActive = caller;
        }

        // const updateActiveItem = (active, next) => {
        //  active.remove('is-active');
        //  next.classList.add('is-active');
        // }

        const isTopRow = activeIndex <= numPerRow - 1;
        const isBottomRow = activeIndex >= gridNum - numPerRow;
        const isLeftColumn = activeIndex % numPerRow === 0;
        const isRightColumn = activeIndex % numPerRow === numPerRow - 1 || activeIndex === gridNum - 1;

        if (isTopRow && isLeftColumn) {
          console.log('Top left');
          console.log(numPerRow);
        }
        if (isTopRow && !isLeftColumn && !isRightColumn) {
          console.log('Top row');
        }
        if (isTopRow && isRightColumn) {
          console.log('Top right');
        }

        console.log('number per row', numPerRow);
        console.log('active index', activeIndex);
        console.log('current active', this.currentActive);
        console.log('called by', caller);
      }
    }

    get contentOpen() {
      return this._internals.states.has("is-content-open");
    }

    set contentOpen(flag) {
      if (flag) {
        try {
          this._internals.states.add("contentOpen");
        } catch {
          this._internals.states.add("--contentOpen");
        }
      } else {
        try {
          this._internals.states.delete("contentOpen");
        } catch {
          this._internals.states.delete("--contentOpen");
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
